type FormWithTitleContainerProps = React.PropsWithChildren & {
  title: string
}

export const FormWithTitleContainer = ({
  title,
  children,
}: FormWithTitleContainerProps) => (
  <aside className="flex flex-col gap-4 sm:gap-2">
    <span className="mt-4 text-xs text-blue-400">{title}</span>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-2 lg:grid-cols-3">
      {children}
    </div>
  </aside>
)
